/* LimeLift — scripts propios (prefijo ll-) */
(function () {
  'use strict';

  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Animaciones de entrada ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.ll-reveal:not(.ll-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ll-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ll-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Carrito ---------- */
  function raiz() { return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'; }

  function anadir(id, cantidad) {
    return fetch(raiz() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(cantidad) || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Error');
        return j;
      });
    });
  }

  function actualizarBurbuja() {
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-icon-bubble'];
        var destino = document.getElementById('cart-icon-bubble');
        if (!html || !destino) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nuevo = tmp.querySelector('.shopify-section') || tmp;
        destino.innerHTML = nuevo.innerHTML;
      })
      .catch(function () {});
  }

  function abrirCajon() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon || typeof cajon.renderContents !== 'function') return Promise.resolve(false);
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (secciones) {
        if (!secciones || !secciones['cart-drawer']) return false;
        cajon.classList.remove('is-empty');
        cajon.renderContents({ sections: secciones });
        return true;
      })
      .catch(function () { return false; });
  }

  /* Botón rápido de las tarjetas (solo productos de una variante) */
  function initRapido() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-ll-rapido]');
      if (!btn) return;
      ev.preventDefault();
      btn.disabled = true;
      anadir(btn.getAttribute('data-ll-rapido'), 1)
        .then(function () {
          abrirCajon().then(function (ok) { if (!ok) actualizarBurbuja(); });
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg>';
        })
        .catch(function () { window.location.href = btn.getAttribute('data-ll-url') || '/cart'; })
        .finally(function () { setTimeout(function () { btn.disabled = false; }, 800); });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    document.querySelectorAll('[data-ll-pdp]').forEach(function (raizPdp) {
      if (raizPdp.dataset.llIniciada) return;
      raizPdp.dataset.llIniciada = '1';

      var principal = raizPdp.querySelector('[data-ll-principal]');
      raizPdp.querySelectorAll('[data-ll-mini]').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          principal.src = mini.getAttribute('data-ll-src');
          principal.srcset = '';
          raizPdp.querySelectorAll('[data-ll-mini]').forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
        });
      });

      var cant = raizPdp.querySelector('[data-ll-cantidad]');
      raizPdp.querySelectorAll('[data-ll-mas],[data-ll-menos]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!cant) return;
          var v = parseInt(cant.value, 10) || 1;
          v = b.hasAttribute('data-ll-mas') ? v + 1 : Math.max(1, v - 1);
          cant.value = v;
        });
      });

      var datos = raizPdp.querySelector('[data-ll-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var inputId = raizPdp.querySelector('[data-ll-id]');
      var precio = raizPdp.querySelector('[data-ll-precio]');
      var tachado = raizPdp.querySelector('[data-ll-tachado]');
      var ahorro = raizPdp.querySelector('[data-ll-ahorro]');
      var boton = raizPdp.querySelector('[data-ll-boton]');
      var textoBoton = boton ? boton.getAttribute('data-ll-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-ll-agotado') : '';
      var formato = raizPdp.getAttribute('data-ll-moneda') || '{{amount_with_comma_separator}} €';

      function dinero(cent) {
        var n = (cent / 100).toFixed(2);
        var coma = n.replace('.', ',');
        return formato
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, coma.split(',')[0])
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, n.split('.')[0])
          .replace(/\{\{\s*amount\s*\}\}/, n);
      }

      function seleccion() {
        var sel = [];
        raizPdp.querySelectorAll('[data-ll-opcion]').forEach(function (grupo) {
          var marcado = grupo.querySelector('input:checked');
          sel.push(marcado ? marcado.value : null);
          var span = grupo.querySelector('[data-ll-valor]');
          if (span && marcado) span.textContent = marcado.value;
        });
        return sel;
      }

      function actualizar() {
        if (!variantes.length) return;
        var sel = seleccion();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return sel[i] === null || sel[i] === undefined || o === sel[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.textContent = textoAgotado; }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        var rebaja = v.compare_at_price && v.compare_at_price > v.price;
        if (tachado) { tachado.hidden = !rebaja; if (rebaja) tachado.textContent = dinero(v.compare_at_price); }
        if (ahorro) { ahorro.hidden = !rebaja; if (rebaja) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? textoBoton : textoAgotado; }
        if (v.featured_image && principal) { principal.src = v.featured_image; principal.srcset = ''; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      raizPdp.querySelectorAll('[data-ll-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
      seleccion();

      var form = raizPdp.querySelector('[data-ll-form]');
      var mensaje = raizPdp.querySelector('[data-ll-mensaje]');
      if (form) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          if (boton) boton.disabled = true;
          if (mensaje) { mensaje.textContent = ''; mensaje.classList.remove('is-error'); }
          anadir(inputId.value, cant ? cant.value : 1)
            .then(function () {
              abrirCajon().then(function (ok) { if (!ok) actualizarBurbuja(); });
              if (mensaje) mensaje.innerHTML = raizPdp.getAttribute('data-ll-ok') + ' <a href="' + (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '" style="color:inherit;text-decoration:underline">' + raizPdp.getAttribute('data-ll-ver') + '</a>';
            })
            .catch(function (e) {
              if (mensaje) { mensaje.textContent = e.message; mensaje.classList.add('is-error'); }
            })
            .finally(function () { if (boton) boton.disabled = false; actualizar(); });
        });
      }
    });
  }

  // Muestras de color en las tarjetas: al pasar por encima cambia la foto principal
  function initMuestras() {
    document.addEventListener('mouseover', function (ev) {
      var m = ev.target.closest('[data-ll-muestra]');
      if (!m) return;
      var tarjeta = m.closest('.ll-card');
      var foto = tarjeta && tarjeta.querySelector('[data-ll-foto]');
      if (!foto) return;
      if (!foto.dataset.llOriginal) foto.dataset.llOriginal = foto.currentSrc || foto.src;
      foto.removeAttribute('srcset');
      foto.src = m.getAttribute('data-ll-muestra');
      tarjeta.querySelectorAll('.ll-muestra').forEach(function (x) { x.classList.toggle('is-activa', x === m); });
    });
  }

  /* ---------- Llavero de regalo desde 50 € ----------
     El descuento automático "Llavero gratis desde 50 €" lo deja a 0 €;
     aquí solo se añade/quita del carrito y se muestra el aviso. */
  var REGALO_ID = 60150707028313; // Llavero Gym LimeLift (enlazado en AutoDS)
  var REGALO_MINIMO = 5000; // céntimos
  var ajustando = false;

  function euros(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }

  function pedirCarrito() {
    return fetch(raiz() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Quita una línea del carrito por su clave (el regalo puede partirse en varias líneas)
  function quitarLinea(clave) {
    return fetch(raiz() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: 0 })
    });
  }

  function refrescarCarrito() {
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var cajon = document.querySelector('cart-drawer');
    var abierto = cajon && cajon.classList.contains('active');
    if (abierto) abrirCajon(); else actualizarBurbuja();
  }

  function pintarAviso(carrito) {
    var regalo = carrito.items.some(function (i) { return i.variant_id === REGALO_ID; });
    var base = carrito.items.reduce(function (s, i) { return i.variant_id === REGALO_ID ? s : s + i.final_line_price; }, 0);
    var html = '';
    if (base > 0) {
      var pct = Math.min(100, Math.round(base / REGALO_MINIMO * 100));
      html = base >= REGALO_MINIMO || regalo
        ? '<p>🎁 <strong>¡Llavero Gym de regalo añadido!</strong> Va gratis en tu pedido.</p>'
        : '<p>Te faltan <strong>' + euros(REGALO_MINIMO - base) + '</strong> para llevarte <strong>gratis el llavero Gym</strong> 🎁</p>';
      html += '<div class="ll-regalo__barra"><span style="width:' + pct + '%"></span></div>';
    }
    var sitios = document.querySelectorAll('cart-drawer .drawer__footer, #main-cart-footer .cart__blocks');
    sitios.forEach(function (sitio) {
      var aviso = sitio.querySelector('.ll-regalo');
      if (!html) { if (aviso) aviso.remove(); return; }
      if (!aviso) {
        aviso = document.createElement('div');
        aviso.className = 'll-regalo';
        sitio.insertBefore(aviso, sitio.firstChild);
      }
      if (aviso.innerHTML !== html) aviso.innerHTML = html;
    });
  }

  // Las revisiones van en cola para que dos cambios seguidos no añadan el regalo dos veces
  var cola = Promise.resolve();

  function revisarRegalo() {
    cola = cola.then(ajustarRegalo).catch(function () {});
  }

  function ajustarRegalo() {
    return pedirCarrito().then(function (carrito) {
      var lineas = carrito.items.filter(function (i) { return i.variant_id === REGALO_ID; });
      var actual = lineas.reduce(function (s, i) { return s + i.quantity; }, 0);
      var base = carrito.items.reduce(function (s, i) { return i.variant_id === REGALO_ID ? s : s + i.final_line_price; }, 0);
      var objetivo = base >= REGALO_MINIMO ? 1 : 0;
      if (actual === objetivo) { pintarAviso(carrito); return; }
      ajustando = true;
      var paso = Promise.resolve();
      if (actual > 0) lineas.forEach(function (l) { paso = paso.then(function () { return quitarLinea(l.key); }); });
      if (objetivo === 1) paso = paso.then(function () { return anadir(REGALO_ID, 1); });
      return paso
        .then(pedirCarrito)
        .then(function (nuevo) { pintarAviso(nuevo); refrescarCarrito(); })
        .finally(function () { ajustando = false; });
    });
  }

  function initRegalo() {
    // Vigila las peticiones del tema al carrito (añadir, cambiar cantidad, vaciar)
    var fetchOriginal = window.fetch;
    window.fetch = function (url) {
      var p = fetchOriginal.apply(this, arguments);
      var ruta = typeof url === 'string' ? url : (url && url.url) || '';
      if (!ajustando && /\/cart\/(add|change|update|clear)/.test(ruta)) {
        p.then(function () { setTimeout(revisarRegalo, 150); }).catch(function () {});
      }
      return p;
    };
    // El cajón se vuelve a pintar tras cada cambio: reponer el aviso
    var cajon = document.querySelector('cart-drawer');
    if (cajon && 'MutationObserver' in window) {
      var espera;
      new MutationObserver(function () {
        clearTimeout(espera);
        espera = setTimeout(function () {
          if (!cajon.querySelector('.ll-regalo')) pedirCarrito().then(pintarAviso).catch(function () {});
        }, 200);
      }).observe(cajon, { childList: true, subtree: true });
    }
    revisarRegalo();
  }

  /* ---------- Calculadora de talla ideal ---------- */
  var TALLAS = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  // Medida máxima (cm) de cada talla, de XS a XXL; por encima, la siguiente
  var TOPES = {
    cintura: [63, 68, 73, 79, 85, 92],
    cadera: [89, 94, 99, 105, 111, 118],
    pecho: [82, 86, 91, 97, 103, 109],
    peso: [49, 56, 64, 72, 81, 90]
  };

  function tallaNormal(valor) {
    var m = String(valor).toUpperCase().replace(/\s+/g, '').match(/^(3XL|XXXL|2XL|XXL|XL|XS|S|M|L)/);
    if (!m) return null;
    return m[1] === 'XXXL' ? '3XL' : (m[1] === '2XL' ? 'XXL' : m[1]);
  }

  function indicePorMedida(tipo, valor) {
    var topes = TOPES[tipo];
    for (var i = 0; i < topes.length; i++) if (valor <= topes[i]) return i;
    return topes.length;
  }

  function initTalla() {
    // Botón de la guía de tallas: abre la calculadora
    document.querySelectorAll('[data-ll-abrir-talla]').forEach(function (btn) {
      if (btn.dataset.llIniciada) return;
      btn.dataset.llIniciada = '1';
      btn.addEventListener('click', function () {
        var calc = btn.closest('[data-ll-pdp]').querySelector('[data-ll-talla]');
        if (!calc) return;
        calc.open = true;
        calc.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'center' });
      });
    });
    document.querySelectorAll('[data-ll-talla]').forEach(function (caja) {
      if (caja.dataset.llIniciada) return;
      caja.dataset.llIniciada = '1';
      var campos = {};
      caja.querySelectorAll('[data-ll-t]').forEach(function (inp) { campos[inp.getAttribute('data-ll-t')] = inp; });
      // Recuerda las medidas de esta visitante para no pedirlas en cada producto
      try {
        var guardadas = JSON.parse(localStorage.getItem('ll-medidas') || '{}');
        Object.keys(guardadas).forEach(function (k) { if (campos[k]) campos[k].value = guardadas[k]; });
      } catch (e) {}

      var salida = caja.querySelector('[data-ll-t-resultado]');
      caja.querySelector('[data-ll-t-calcular]').addEventListener('click', function () {
        var v = {};
        Object.keys(campos).forEach(function (k) { var n = parseFloat(campos[k].value); if (n > 0) v[k] = n; });
        try { localStorage.setItem('ll-medidas', JSON.stringify(v)); } catch (e) {}
        if (!v.peso && !v.cintura && !v.cadera && !v.pecho) {
          salida.innerHTML = 'Escribe al menos tu peso (o tus medidas) para calcularla.';
          return;
        }
        var porCm = [];
        if (v.cintura) porCm.push(indicePorMedida('cintura', v.cintura));
        if (v.cadera && caja.getAttribute('data-ll-cadera') === 'true') porCm.push(indicePorMedida('cadera', v.cadera));
        if (v.pecho && caja.getAttribute('data-ll-pecho') === 'true') porCm.push(indicePorMedida('pecho', v.pecho));
        var idx = porCm.length ? Math.max.apply(null, porCm) : indicePorMedida('peso', v.peso);
        // Sin medidas: con poca altura para el peso, una talla más
        if (!porCm.length && v.altura && v.peso && v.peso / Math.pow(v.altura / 100, 2) >= 27) idx++;
        var ajuste = parseInt(caja.getAttribute('data-ll-ajuste'), 10) || 0;
        idx = Math.max(0, Math.min(TALLAS.length - 1, idx + ajuste));

        // Tallas que existen en este producto
        var pdp = caja.closest('[data-ll-pdp]');
        var grupo = null;
        pdp.querySelectorAll('[data-ll-opcion]').forEach(function (g) {
          var leyenda = (g.querySelector('legend') || {}).textContent || '';
          if (/talla|size|tama/i.test(leyenda)) grupo = g;
        });
        var disponibles = [];
        if (grupo) grupo.querySelectorAll('input[type=radio]').forEach(function (inp) {
          var t = tallaNormal(inp.value);
          if (t) disponibles.push({ i: TALLAS.indexOf(t), t: t, inp: inp });
        });
        disponibles.sort(function (a, b) { return a.i - b.i; });
        if (!disponibles.length) { salida.innerHTML = 'Te recomendamos la talla <strong>' + TALLAS[idx] + '</strong>.'; return; }

        var elegida = disponibles.find(function (d) { return d.i >= idx; });
        var justa = false;
        if (!elegida) { elegida = disponibles[disponibles.length - 1]; justa = true; }
        elegida.inp.checked = true;
        elegida.inp.dispatchEvent(new Event('change', { bubbles: true }));

        var html = 'Tu talla ideal: <strong>' + elegida.t + '</strong> ✓ <span>(ya la hemos seleccionado)</span>';
        if (ajuste > 0) html += '<br>Esta prenda talla pequeño, por eso te recomendamos una más.';
        if (justa) html += '<br>Es la talla más grande de esta prenda y puede quedarte justa.';
        else html += '<br>Si te gusta más holgada, elige la siguiente.';
        salida.innerHTML = html;
      });
    });
  }

  function iniciar() {
    initReveal();
    initProducto();
    initTalla();
  }

  document.addEventListener('DOMContentLoaded', function () { iniciar(); initRapido(); initMuestras(); initRegalo(); });
  document.addEventListener('shopify:section:load', iniciar);
})();
